<template>
    <div class="container">
        <div class="searchBox">
            <!-- <div class="left">
                <el-form :inline="true">
                    <el-form-item label="客户总数"> ：共{{customerTotal}} 位
                    </el-form-item>
                    <el-form-item>
                        <el-input placeholder="手机号/公司名称" v-model="formObj.fuzzyQuery" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button icon="el-icon-search" type="primary" @click="fuzzySearchClick">查询</el-button>
                    </el-form-item>
                </el-form>
            </div> -->
            <div class="right">
                <!-- <el-form :inline="true">
                    <el-form-item>
                        <el-select placeholder="全部身份" v-model="formObj.userType" @change="multiSearchClick">
                            <el-option label="全部身份" value=""></el-option>
                            <el-option :label="list.text" :value="list.value" :key="index" v-for="(list,index) in userTypeOptions"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select placeholder="全部审核状态" v-model="formObj.authResult" @change="multiSearchClick">
                            <el-option label="全部审核状态" value=""></el-option>
                            <el-option :label="list.text" :value="list.value" :key="index"  v-for="(list,index) in authResultOptions"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form> -->
                <el-button type="primary" @click="toAdd">新增商家+</el-button>
                <el-button type="primary">下载商家列表</el-button>
            </div>
        </div>
        <div class="tableBox">
            <el-table v-loading="isLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)" ref="multipleTable" border stripe :data="tableData"
                tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
            <!--    <el-table-column type="selection" width="55">
                </el-table-column> -->
             <!--   <el-table-column label="" width="70">
                    <template slot-scope="scope">{{ total-((searchObj.page-1)*searchObj.num+ scope.$index) }}</template>
                </el-table-column> -->
                <el-table-column label="ID" width="60">
                    <template slot-scope="scope">{{ scope.row.store_id }}</template>
                </el-table-column>
                <el-table-column label="联系人姓名" width="100">
                    <template slot-scope="scope">{{ scope.row.merchant_user_realname }}</template>
                </el-table-column>
                <!-- <el-table-column label="手机号码">
                    <template slot-scope="scope">{{ scope.row.merchant_user_cellphone }}</template>
                </el-table-column> -->
                <el-table-column label="店铺名称">
                    <template slot-scope="scope">{{ scope.row.store_name}}</template>
                </el-table-column>
                <el-table-column label="店铺排序">
                    <template slot-scope="scope">{{ scope.row.store_list_sequence}}</template>
                </el-table-column>
                <el-table-column label="地图图标排序">
                    <template slot-scope="scope">{{ scope.row.store_map_sequence }}</template>
                </el-table-column>
                <!-- <el-table-column label="开通时间" >
                    <template slot-scope="scope">{{ scope.row.merchant_submit_time }}</template>
                </el-table-column> -->
                <el-table-column label="所在园区" >
                    <template slot-scope="scope">
                    <!-- {{ scope.row.store_park_id_str}} -->
                    <span  v-for="(list,index) in parkWord" v-if="list.value==scope.row.store_park_id">{{list.text}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="审核状态" >
                    <template slot-scope="scope">
                        <!-- <span :class="{green:scope.row.user_type==1,blue:scope.row.user_type==2}">{{ scope.row.user_type | turnValToText("user_type")}}</span> -->
                        <span :class="{orange:scope.row.store_state=='n',green:scope.row.store_state=='y',red:scope.row.store_state=='p'}">{{ scope.row.store_state |turnStatus}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="主营类目">
                    <template slot-scope="scope">{{scope.row.mainCategoryStr}} </template>
                </el-table-column>
                <el-table-column label="价格区间">
                    <template slot-scope="scope">{{scope.row.priceRange}} </template>
                </el-table-column>
                <el-table-column label="门店地址">
                    <template slot-scope="scope">{{scope.row.region_city_string+scope.row.address_string}} </template>
                </el-table-column>
                <el-table-column label="操作" width="360">
                    <template slot-scope="scope">
                        <div style="text-align: left;" class="controlBox">
                            <div class="buttonInline">
                              <el-button type="primary" size="mini" @click="toDetail(scope.row.store_id)">查看</el-button>
                              <el-button type="primary" size="mini" @click="toEdit(scope.row.store_id)">编辑</el-button>
                            </div>

                            <div class="buttonInline" style="width: 60px;">
                              <el-button type="success" size="mini" @click="toViewGoods(scope.row.store_id)" v-if="scope.row.imgFile&&scope.row.imgFile.length>0">查看商品</el-button>
                            </div>
                            <div class="buttonInline">
                              <el-button type="success" size="mini" @click="toAddGoods(scope.row.store_id)">编辑商品</el-button>
                            </div>

                            <el-switch @change=changeIsShow(scope.row.store_id) v-model="scope.row.isShow" >
                            </el-switch>
                            <span v-if="scope.row.isShow" style="color:#409EFF">已展示</span>
                            <span v-if="!scope.row.isShow" style="color:#bbb">已隐藏</span>
                            <div class="buttonInline" style="width: 40px;margin-left:10px;">
                              <el-button type="danger" size="mini" @click="openAuth(scope.row.store_id,scope.row.store_name)" v-if="scope.row.store_state=='p'">审核</el-button>
                            </div>
                            <!-- <div style="height: 10px;"></div> -->

                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="searchObj.page"
                :page-size.sync="searchObj.num" layout="total, sizes, prev, pager, next, jumper" :total="total"
                background>
            </el-pagination>
        </div>
        <!-- 审核模块 -->
        <div class="authModalWrap">
          <authModal :name="authListName" :id="authListId" @close="closeAuth" @refreshPage="refreshPage" v-show="isShowAuth" ></authModal>

        </div>
    </div>
</template>

<script>
    import authModal from '@/components/authModal'
    import {
        json,
        wordData
    } from '@/common/common.js'
    import {
        ajaxPost
    } from '@/common/request.js'
    import {
        utils
    } from '@/common/common.js'
    export default {
        name: 'adminIndex',
        data() {
            return {
                isShowAuth:false,
                authListName:'',
                authListId:'',
                lastPage:'',
                newLinkParamObj:{},
                isShowAddOrderModal:false,
                isLoading: false,
                msg: 'Welcome to Your Vue.js App',
                formObj: {
                    fuzzyQuery: '',
                    userType: '',
                    authResult: '',
                },
                searchObj: {
                    page: 1,
                    num: 10,
                },
                //表格
                tableData: [],
                multipleSelection: [],
                //分页
                total: 0,
                isShowModal: false,
                parkWord:[],

            }
        },
        computed: {
            adminId() {
               return utils.getAdminId()
            },

        },
        components: {authModal},
        methods: {
            changeIsShow(id){
              let _this = this
              let arg={
                adminId:_this.adminId,
                storeId:id,
              }
              ajaxPost('/store/updateStoreStatus', arg).then(function(res) {
                if(res.errorCode==200){
                  _this.$message({
                      message: "切换商家状态成功", //接口返回一个页面
                      type: 'success',
                      duration: 1500
                  });
                  _this.getTableLists()
                }else{
                  alert("切换失败")
                }


              }, function(res) {
              })
            },
            openAuth(id,name){
              this.authListName=name
              this.authListId=id
              this.isShowAuth=true

            },
            closeAuth(){
              this.authListName=""
              this.authListId=""
              this.isShowAuth=false
            },
            refreshPage(){
              this.getTableLists()
            },
            getParams(){
              this.lastPage=this.$route.query.from
            },
            toAddGoods(id){
              this.$router.push({
                    name:'goodsAdd',
                    params:{
                        id:id,
                   }
              })
            },
            toViewGoods(id){
              this.$router.push({
                    name:'goodsDetail',
                    params:{
                        id:id,
                   }
              })
            },
            toAdd(){
              this.$router.push("/business/add")
            },
            toEdit(id){
              this.$router.push({
                    name:'businessEdit',
                    params:{
                        id:id,
                   }
              })

            },
            toDetail(id){
              this.$router.push({
                    name:'businessDetail',
                    params:{
                        id:id,
                   }
              })

            },
            back() {
                this.$router.back()
            },
            getTableLists() {
                let _this = this
                this.isLoading = true
                ajaxPost('/store/getStoreList', this.searchObj).then(function(res) {
                    _this.tableData = []
                    _this.isLoading = false
                    if (res.data && res.data.storeList) {
                        _this.total =parseInt(res.data.totalCount)
                        res.data.storeList.forEach(function(item, index) {
                            let buffer = item
                            buffer.isShow=item.store_visible=='y'?true:false
                            try{
                              buffer.mainCategoryStr=JSON.parse(buffer.mainCategory).join(" 、 ")
                            }catch(err){
                              buffer.mainCategoryStr=buffer.mainCategory
                            }

                            // buffer.store_park_id_str=_this.getItsParkName(buffer.store_park_id)

                            _this.tableData.push(buffer)

                        })

                    }
                }, function(res) {
                    _this.isLoading = false
                })
            },
            getParkWord(){
              let _this = this
              ajaxPost('/park/getParkList', {}).then(function(res) {
                if (res.data) {
                  _this.parkWord = []
                  _this.parkWord = res.data.map(function(item, index) {
                    let buffer = {}
                    buffer.value = item.park_id
                    buffer.text = item.park_name
                    return buffer
                  })

                }
              }, function(res) {})

            },
            getItsParkName(val){
              let _this=this
              let result=""
              _this.parkWord.forEach(function(item,index){
                if(item.value==val){
                  result=item.text
                  return false
                }
              })
              return result

            },
            handleSizeChange(size) { //分页：每页n条
                this.searchObj.num = size
                this.searchObj.page = 1
                this.getTableLists()
            },
            handleCurrentChange(page) { //分页：改变第n页
                this.searchObj.page = page
                this.getTableLists()
            },
            handleSelectionChange(val) { //表格多选框
                this.multipleSelection = val;
                console.log(this.multipleSelection)
            }
        },
        created() {
            console.log("执行created")
        	//获取session里存储的搜索条件，并赋值给当前表单
            this.getParams()

            let _this = this
            let sessionSearch=utils.getSearchObjFromSession()
            if(sessionSearch){
                console.log("session里存储了搜索条件")
                _this.searchObj=sessionSearch
                this.formObj.fuzzyQuery=_this.searchObj.fuzzyQuery
                this.formObj.userType=_this.searchObj.userType
                this.formObj.authResult=_this.searchObj.authResult
            }else if(_this.lastPage=='home'){
                _this.searchObj.authResult='p'
                this.formObj.authResult=_this.searchObj.authResult
            }else{
                console.log("session里没有搜索条件，也不是首页直接跳转")
            }
            console.log(_this.searchObj,'mounted里的搜索条件1111')
            this.getTableLists()

        },
        mounted(){
            console.log("执行mounted")
            this.getParkWord()
        }
    }
</script>

<style scoped lang="scss">
    * {
        // outline: 1px solid blue;
    }
    .controlBox button{padding:4px;font-size: 12px;}
    .el-switch__label {font-size: 12px;}
    .buttonInline{display: inline-block;}
    .container {}

    .searchBox {
        padding: 0.25rem 0.25rem 0;

        .left {
            float: left;
        }

        .right {
            float: right;
        }
    }

    .searchBox:after {
        content: "";
        display: block;
        clear: both;
    }

    .tableBox {
        padding: 0.25rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/business/list.vue